import Axios from "../../../networking/interceptor";

import { createAsyncThunk } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { driver_add_message_to_group } from "../../../networking/urlEndPoints";

export const handleAddMessageToGroup = createAsyncThunk('addmessagetogroup', async (requestedData, { rejectWithValue }) => {
    try {
        const response = await Axios.post(driver_add_message_to_group, requestedData, {
            headers: {
                "Content-Type": "multipart/form-data",
                "Accept": "multipart/form-data",
            }
        })

        const data = response.data;
        return data;
    } catch (error) {
        return rejectWithValue(error.response)
    }
})

const initialState = {
    loading: false,
    data: null,
    error: null
}

const handleAddMessageToGroupSlice = createSlice({
    name: 'addmessagetogroup',
    initialState,

    extraReducers: (builder) => {
        builder.addCase(handleAddMessageToGroup.pending.type, (state) => {
            return {
                ...state,
                loading: true,
                data: null,
                error: null
            }
        })

        builder.addCase(handleAddMessageToGroup.fulfilled.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null
            }
        })

        builder.addCase(handleAddMessageToGroup.rejected.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: null,
                error: action.payload
            }
        })
    }

})

export default handleAddMessageToGroupSlice.reducer